export const FormFields = {
    ARN_ENDPOINT: 'arnEndpoint',
};

export const NO_BOT_TRIGGER_ERR = 'Bot trigger information not received from server';

export const CLOUD_BOTS_INFO_URL = 'https://cloudbots.dome9.com/';
export const FIX_IT_MAX_CLOUD_BOTS_ALLOWED = 5;
